
import { AlertCircle, CreditCard } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { useCurrency } from "@/contexts/CurrencyContext";
import { Subscription } from "@/types/subscription";

interface SubscriptionRenewalProps {
  subscription: Subscription;
  onRenew: () => void;
  isExpiringSoon: boolean;
  featured?: boolean;
}

export function SubscriptionRenewal({ subscription, onRenew, isExpiringSoon, featured = false }: SubscriptionRenewalProps) {
  const { t } = useTranslation(["subscriptions"]);
  const { formatCurrency } = useCurrency();

  // Convert price to number before formatting
  const price = typeof subscription.price === 'string' 
    ? parseFloat(subscription.price) || 0 
    : subscription.price || 0;

  if (featured) {
    return (
      <div className="mt-6">
        {isExpiringSoon && (
          <div className="mb-3 flex items-center gap-2 text-xs text-primary">
            <AlertCircle className="h-4 w-4" />
            <span>{t("expiringSoonTitle")}</span>
          </div>
        )}
        <Button onClick={onRenew} className="athlete-cta h-12 w-full font-bold">
          <CreditCard className="mr-2 h-4 w-4" />
          {t("renewSubscription", { ns: "subscriptions" })}
        </Button>
      </div>
    );
  }

  return (
    <div className="flex flex-col justify-center items-center p-4 bg-slate-50 dark:bg-slate-900 rounded-lg">
      <div className="text-center mb-4">
        <h3 className="text-lg font-bold">
          {t(`plans.${subscription.type.toLowerCase()}.title`, { ns: "subscriptions", defaultValue: subscription.type })}
        </h3>
        <p className="text-3xl font-bold text-amber-500 mt-2">
          {formatCurrency(price)}
        </p>
      </div>
      
      {isExpiringSoon && (
        <div className="flex items-center gap-2 text-orange-600 mb-4 text-sm">
          <AlertCircle className="h-4 w-4" />
          <span>{t("subscriptions.daysLeft", { ns: "athlete" })}</span>
        </div>
      )}
      
      <Button 
        onClick={onRenew}
        className="w-full"
      >
        <CreditCard className="mr-2 h-4 w-4" />
        {t("renewSubscription", { ns: "subscriptions" })}
      </Button>
    </div>
  );
}
